import { render } from "./Resources.vue?vue&type=template&id=a0877f96"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
script.render = render

export default script